<div class="d-flex justify-content-start align-items-start w-100 h-100 login-container m-5 p-5">
  <div class="col-xl-4 col-md-6 col-10">
    <div class="card border-0 box-shadow rounded-0">
      <div class="card-header d-flex justify-content-center logo-bg align-items-center border-0 box-shadow">
          <img class="logo" src="assets/img/app/aladdin-icon-blue.png">
      </div>
      <div class="card-body text-center pb-1">
        <h2>Login</h2>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="text-left mt-4" data-testid="test-external-login-form">
          <div [hidden]="!showLogin">
            <div class="form-group">
              <input
                  [formControl]="UserName"
                  class="form-control validation-field"
                  placeholder="User Name"
                  type="text"
                  #usernameField
                  data-testid="test-external-login-user-name">
              <small class="text-danger"
                  *ngIf="form.get('UserName').touched && form.get('UserName').hasError('required')">User Name
                  is required</small>
            </div>
            <div class="form-group">
              <input
                  [formControl]="UserPassword"
                  class="form-control validation-field"
                  placeholder="Password"
                  type="password"
                  #passwordField
                  data-testid="test-external-login-user-password">
              <small class="text-danger"
                  *ngIf="form.get('UserPassword').touched && form.get('UserPassword').hasError('required')">Password
                  is required</small>
              <small class="text-danger"
                  *ngIf="form.get('UserPassword').touched && form.get('UserPassword').hasError('minlength')">Password
                  isn't long enough, minimum of 6 characters</small>
            </div>
            <div class="d-flex align-center pl-2 mb-2">
                <input [(ngModel)]="saveUsername" [ngModelOptions]="{standalone: true}" type="checkbox" id="save-username" class="d-inline-block" data-testid="test-external-login-save-username-checkbox"/>
                <div class="ml-2 form-check-label" for="save-username">Remember Username?</div>
                <div class="flex-grow-1">&nbsp;</div>
            </div>
          </div>
          <div [hidden]="!showCode">
            <div class="h4">
              *An authentication code has been dispatched to the number ending in {{phoneSuffix}}. Kindly input the code to validate your login.
            </div>
            <div class="d-flex align-center mb-2">
                <input placeholder="Multi-Factor Auth Code"  [formControl]="MfaCode" type="tel" class="form-control" data-testid="test-external-login-mfa-code-tel"/>
            </div>
          </div>
          <div [hidden]="!showPhone">
            <div class="h4 my-4">
              *Kindly provide a mobile verification number to enhance the security and authentication of your account for future verification purposes
            </div>
            <div class="d-flex align-center mb-2">
              <input placeholder="Phone Number" class="text-dark form-control" type="tel" [textMask]="{ mask: phoneMask, guide: false }" [formControl]="NewPhoneNumber" data-testid="test-external-login-new-phone-number-tel"/>
            </div>
            <div class="h5 text-center">
              By checking the box below, you consent to receive SMS communications from Aladdin. You also acknowledge and agree to abide by our Privacy Policy, accessible through the following link
            </div>
            <div class="h4 text-warning d-flex justify-content-center">
              <a class="my-1 text-warning" target="_blank" href="https://aladdincap.com/frequently-asked-questions" data-testid="test-external-login-click-here-for-aladdin">
                  <u>Click Here for Aladdin's Privacy Policy</u>
              </a>
              <div class="my-0 ml-5 ">
                  <input class="big-checkbox" type="checkbox" [formControl]="SmsConsent" data-testid="test-external-login-sms-consent-checkbox">
              </div>
            </div>
          </div>
          <div class="error-message" role="alert" *ngIf="errorMessage">
            <div class="d-flex flex-nowrap">
              <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
              <span class="mx-1">{{errorMessage}}</span>
              <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
            </div>
          </div>

          <div class="form-group">
            <button [disabled]="!form.valid || isLoading  || (showPhone && (!form.value.SmsConsent || !form.value.NewPhoneNumber))" class="btn btn-block silver-lake-blue" type="submit" [hidden]="showSuccess" data-testid="test-external-login-sign-in">
              <span *ngIf="!isLoading && showLogin">Sign In</span>
              <span *ngIf="!isLoading && showCode">Submit Code</span>
              <span *ngIf="!isLoading && showPhone">Submit Phone</span>
              <span *ngIf="isLoading">Please wait...</span>
            </button>
          </div>

          <div class="form-group mt-2 pt-2" *ngIf="showPhone || showCode">
            <hr>
            <button [disabled]="!form.valid || isLoading" class="btn btn-block btn-secondary" (click)="startOver()" data-testid="test-external-login-back-to-login-page">
              <span >Back to Login Page</span>
            </button>
          </div>
        </form>
        <div *ngIf="showSuccess">
          <i class="fa-solid fa-party-horn fa-shake fa-lg"></i>
          <div>
            You would have been logged in
          </div>
          <div>
            <button class="btn btn-primary" (click)="startOver()" data-testid="test-external-login-start-over">Start over</button>

          </div>
          <i class="fa-solid fa-champagne-glasses fa-beat fa-lg"></i>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/components/test-external-login/test-external-login.component.html